var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');
var ExacerbationsView = require('./exacerbations-view');
var Dicts = require('../../data/dicts');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var DiseasesForm = Marionette.View.extend({
    template: require('../../templates/medicals/diseases-form.html'),

    regions: {
        exacerbationsRegion: '#exacerbations'
    },

    ui: {
        formModal: '#disease-form-modal',
        save: '#save',

        typeOfId: '#type',
        icdCode: '#icd-code',
        name: '#name',
        startDate: '#start-date',
        stopDate: '#stop-date',
        comment: '#comment',

        searchText: '#search-text',
        searchButton: '#search-button',
        searchResultsTable: '#search-results',

        leftSide: '.inputs'
    },

    events: {
        'click @ui.save': 'saveDisease',
        'keyup input[required]': 'validate',
        'change input[required]': 'validate',
        'keyup @ui.searchText': 'search',
        'click @ui.searchButton': 'search'
    },

    templateContext: function () {
        var that = this;
        return {
            title: that.mode == 'add' ? 'Add disease' : 'Edit disease',
            mode: that.mode,
            name: that.disease.name,
            diseaseId: that.disease.diseaseId,
            typeOfId: Dicts.hl7Dict[that.disease.typeOfId] || that.disease.typeOfId,
            startDate: (that.disease.startDate == '' || that.disease.startDate == null || that.disease.startDate == 0
                ? '' : that.utils.longToDateTimeFormatted(Number(that.disease.startDate), 'MM/DD/YYYY')),
            stopDate: (that.disease.stopDate == '' || that.disease.stopDate == null || that.disease.stopDate == 0
                ? '' : that.utils.longToDateTimeFormatted(Number(that.disease.stopDate), 'MM/DD/YYYY')),
            comment: that.disease.comment
        };
    },

    initialize: function (options) {
        _.bindAll(this, 'onRender', 'showModal', 'hideModal', 'saveDisease',
            'fillDisease', 'validate', 'search', 'tranformICDResponse', 'renderResultInTable',
            'fillFormFromSelectedResult', 'showLoading', 'hideLoading');
        if (options) {
            this.mode = options.mode;
            this.disease = options.disease;
            this.disease.exacerbations = this.disease.exacerbations || [];
            this.servicesAddresses = options.servicesAddresses;
        }
        this.utils = new CommonUtils();
    },

    onRender: function () {
        this.exacerbationsView = new ExacerbationsView({
            exacerbations: this.disease.exacerbations
        });
        this.showChildView('exacerbationsRegion', this.exacerbationsView);

        this.showModal();
        this.ui.searchResultsTable.hide();
        this.ui.save.attr('disabled', true);

        this.ui.startDate.datepicker({
            format: 'mm/dd/yyyy',
            autoclose: true,
            clearBtn: true
        });
        this.ui.stopDate.datepicker({
            format: 'mm/dd/yyyy',
            autoclose: true,
            clearBtn: true
        });

        if (this.mode == 'edit') {
            this.ui.leftSide.removeClass('col-md-6');
            this.ui.leftSide.addClass('col-md-11');
        }
        this.validate();

    },

    showModal: function () {
        this.ui.formModal.modal("show");
    },

    hideModal: function () {
        this.ui.formModal.modal("hide");
    },

    saveDisease: function () {
        if (this.mode == 'add')
            this.triggerMethod('new:disease', this.fillDisease());
        else if (this.mode == 'edit')
            this.triggerMethod('update:disease', this.fillDisease());

        this.hideModal();
    },

    fillDisease: function () {
        this.disease.typeOfId = this.ui.typeOfId.val();
        this.disease.diseaseId = this.ui.icdCode.val();
        this.disease.name = this.ui.name.val();
        this.disease.startDate = this.utils.dateToLong(this.ui.startDate.val());
        this.disease.stopDate = this.utils.dateToLong(this.ui.stopDate.val());
        this.disease.comment = this.ui.comment.val();
        this.disease.exacerbations = this.exacerbationsView.getAllExacerbations() || [];
        return this.disease;
    },

    validate: function () {
        if (this.ui.name.val() != '' && this.ui.icdCode.val() != '') {
            this.ui.save.removeAttr('disabled');
        } else {
            this.ui.save.attr('disabled', true);
        }
    },

    search: function (event) {
        var searchText = this.ui.searchText.val();
        if (searchText.length <= 1) return;

        $('#search-results tr:not(:first)').remove();
        var that = this;
        if (event.keyCode == 13 || event.target.id == that.ui.searchButton.attr('id')) {
            that.showLoading();

            if (typeof that.servicesAddresses["icdServiceAddress"] != "undefined") {
                $.when(
                    $.ajax({
                        type: "GET",
                        url: that.servicesAddresses["icdServiceAddress"] +
                        '/search?terms=' + searchText
                    })
                ).done(function (resp) {
                    that.renderResultInTable(resp || []);
                    that.hideLoading();
                }).fail(function (jqXHR, textStatus) {
                    notificationsChannel.request('show:notification', "Error. ICD service is unavailable");
                    that.hideLoading();
                });
            }
        }
    },

    tranformICDResponse: function (response) {
        return (response || []).map(function (item) {
            return {
                code: item.code,
                name: item.name
            }
        });
    },

    renderResultInTable: function (results) {
        var that = this;

        results.forEach(function (item) {
            var newRowContent = "<tr class='clickable' id='" + item.code + "'><td>"
                + item.code + "</td><td>" + item.name + "</td></tr>";
            $('#search-results tbody').append(newRowContent);
        });

        $("#search-results tr:not(:first)").on('click', function (event) {
            var id = event.currentTarget.id;
            $(this).addClass('selected').siblings().removeClass('selected');
            that.fillFormFromSelectedResult(id, results);
        });
        if (results.length > 0) {
            this.ui.searchResultsTable.show();
        }
    },

    fillFormFromSelectedResult: function (selectedId, results) {
        var selected = _.findWhere(results, {code: selectedId});
        this.disease.diseaseId = selected.code;
        this.disease.name = selected.name;
        this.ui.icdCode.val(selected.code);
        this.ui.name.val(selected.name);
        this.validate();
    },

    showLoading: function () {
        this.utils.showSpinner('#disease-loader');
    },

    hideLoading: function () {
        this.utils.hideSpinner('#disease-loader');
    }

});

module.exports = DiseasesForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/medicals/diseases-form.js
// module id = 357
// module chunks = 0